module.exports = __webpack_public_path__ + "static/media/Corn Cob Guy.b8bdaacb.jpg";